import {pluralizeModelNoun} from './modelNouns'
import {capitalizeNoun} from './staffNouns'
export interface ParticipantNounEvent {participantPronoun?:string;participantNoun?:string}
export function participantNoun(event:ParticipantNounEvent|undefined,fallback:string){return event?.participantNoun?.trim() || event?.participantPronoun?.trim() || fallback}
export function participantNounTerms(event:ParticipantNounEvent|undefined,fallback:string){
 const singular=participantNoun(event,fallback),plural=pluralizeModelNoun(singular)
 return {participantSingular:singular,participantPlural:plural,participantTitle:capitalizeNoun(singular),participantPluralTitle:capitalizeNoun(plural)}
}
